<template>
  <BjDrawerForm ref="BjDrawerForm" :form="form" :rules="rules" label-width="120px" @handleConfirm="handleConfirm">
    <!-- <el-col :span="22">
      <BjFormItemCode v-model="form.code" :readonly="isEdit" label="物流商编码" prop="code" />
    </el-col> -->
    <el-col :span="22">
      <el-form-item :label="$t('businessLogisticsCompany.table.logisticsCompanyName2')" prop="name">
        <BjInput v-model="form.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>
    <!-- <el-col v-if="!isEdit" :span="22">
      <el-form-item label="启用" prop="enableFlag">
        <el-switch v-model="form.enableFlag" :active-value="true" :inactive-value="false" />
      </el-form-item>
    </el-col> -->
  </BjDrawerForm>
</template>
<script>
import { logisticApi } from '@/api';

const getDefaultForm = () => {
  return {
    enableFlag: true,
    id: null,
    name: null,
    objectVersionNumber: null,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
    };
  },
  computed: {
    // 表单校验
    rules() {
      const rules = {
        name: [{ required: true, message: this.$t('businessLogisticsCompanyList.table.logisticsCompanyNameInput'), trigger: 'blur' }],
        enableFlag: [{ required: true, message: this.$t('businessLogisticsCompany.table.chooseText'), trigger: 'change' }],
      };
      return rules;
    }
  },
  watch: {},
  mounted() {},
  methods: {
    afterUpload(res) {
      this.form.logo = res;
    },
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('businessLogisticsCompanyList.editLogisticsCompany') : this.$t('businessLogisticsCompanyList.addLogisticsCompany'));

      this.form = Object.assign(getDefaultForm(), info || {});
    },

    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }

      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    addApi(API_DATA) {
      logisticApi.addLogisticsCompany(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      logisticApi.updateLogisticsCompany(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
